import { useAppDispatch, useAppSelector } from '@app/redux/hooks';
import { selectHeaderData } from '@app/redux/slices/header';
import { selectPopupData, setModalRegion } from '@app/redux/slices/modalWindow';
import { Grid } from '@ui-kit/Grid';
import { useCallback } from 'react';
import CheckedRegion from '@app/Layout/LayoutModal/Modals/CheckedRegion';
import IconMapPoint from './map-point.svg';
import IconRectangle from './rectangle.svg';

import styles from './RegionSelection.module.scss';

export const RegionSelection = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const { popupCheckedRegion } = useAppSelector(selectPopupData);
  const { region } = useAppSelector(selectHeaderData);
  const handleOpenModal = useCallback(() => {
    dispatch(setModalRegion(true));
  }, []);
  return (
    <div className={styles.Container}>
      <Grid gap={'6px'} row at className={styles.Content} onClick={handleOpenModal} data-testid="header-region-selector">
        <IconMapPoint width={12} height={14} />
        {region?.NAME}
        <IconRectangle width={5.66} height={3} />
      </Grid>
      {popupCheckedRegion && <CheckedRegion />}
    </div>
  );
};
